// 커서 위치 계산 및 자동완성 위치 설정
export var calculateCursorPosition = function(inputRef, currentToken) {
    if (!inputRef.current || !currentToken) return null;
    var textarea = inputRef.current;
    var textareaRect = textarea.getBoundingClientRect();
    // 현재 입력의 padding 값을 계산
    var computedStyle = window.getComputedStyle(textarea);
    var paddingLeft = parseFloat(computedStyle.paddingLeft);
    var paddingTop = parseFloat(computedStyle.paddingTop);
    var lineHeight = parseFloat(computedStyle.lineHeight) || 20;
    // 토큰 시작 위치까지의 텍스트 추출
    var textBeforeToken = textarea.value.substring(0, currentToken.startPosition);
    // 줄 수 계산 (특수문자가 몇 번째 줄에 있는지)
    var lines = textBeforeToken.split('\n');
    var tokenLineIndex = lines.length - 1;
    // 현재 줄의 텍스트
    var currentLine = lines[tokenLineIndex] || '';
    // 특수문자의 x 위치 계산
    // 임시 캔버스를 사용하여 텍스트 너비 측정
    var canvas = document.createElement('canvas');
    var context = canvas.getContext('2d');
    if (context) {
        context.font = "".concat(computedStyle.fontSize, " ").concat(computedStyle.fontFamily);
        var tokenXOffset = context.measureText(currentLine).width;
        // 최종 위치 계산
        // 첫 글자이거나 토큰이 줄의 맨 처음에 있는 경우 특별 처리
        var left = textareaRect.left + paddingLeft + tokenXOffset;
        // 토큰이 있는 줄의 y 위치 계산
        var top = textareaRect.top + paddingTop + tokenLineIndex * lineHeight + lineHeight; // 특수문자 아래로 드롭다운 표시
        return {
            top: top + textarea.scrollTop,
            left: left
        };
    }
    // 캔버스 컨텍스트를 얻지 못한 경우, 기본 위치로 대체
    return {
        top: textareaRect.top + paddingTop + lineHeight,
        left: textareaRect.left + paddingLeft
    };
};
